var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDataGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3899_150136)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 8,
  className: "widget_icon_line"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0294 0V32",
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 15L0 15",
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 23L0 23",
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4706 0V32",
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 30.5,
  height: 30.5,
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3899_150136"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})))));
export { SvgDataGrid as ReactComponent };
export default __webpack_public_path__ + "data_grid.dafc89f737e5b2a29d0597d28e2107c1.svg";